import React, { Component } from "react";
import PropTypes from "prop-types";
import omit from "lodash/omit";
import AsyncLoaderController, { LoaderStatus } from "./async-loader-controller";

export default class AsyncLoader extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
    this.renderFailureReason = this.renderFailureReason.bind(this);
  }

  componentWillMount() {
    this.changeLoaderStatusByPromise(this.props.promise);
  }

  componentWillReceiveProps(nextProps) {
    this.changeLoaderStatusByPromise(nextProps.promise);
  }

  changeLoaderStatusByPromise(promise) {
    const oldPromise = this._promise;
    this._promise = promise;
    if (oldPromise === promise) return;
    if (!promise) {
      this.setState({ loader: { status: LoaderStatus.RESET } });
      return;
    }
    this.setState({ loader: { status: LoaderStatus.LOADING } });
    promise.then(
      () => {
        this.setState({ loader: { status: LoaderStatus.LOAD_SUCCESS } });
      },
      err => {
        this.setState({ loader: { status: LoaderStatus.LOAD_FAILED, reasonOfFailure: err } });
      }
    );
  }

  renderFailureReason(props) {
    const children = props.children;
    const restProps = omit(props, "children");
    return (
      <div {...restProps}>
        <p>{children && (children.message || children)}</p>
        <p>
          <button
            className="loaderReason__btn loaderReason__btn--retry btn btn-default"
            type="button"
            onClick={this.props.retry}
          >
            重试
          </button>
        </p>
      </div>
    );
  }

  render() {
    return (
      <AsyncLoaderController
        className={this.props.className}
        {...this.state.loader}
        FailureReasonComponent={this.renderFailureReason}
      >
        {this.props.children}
      </AsyncLoaderController>
    );
  }
}

AsyncLoader.defaultProps = {
  promise: undefined,
  className: "",
  children: undefined,
};

AsyncLoader.propTypes = {
  promise: PropTypes.object,
  retry: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.any,
};
